import {Component, Input, OnInit} from '@angular/core';

@Component({
   selector: 'icofont',
   template: '<i class="icofont" [ngClass]="ico" ></i>',
   styleUrls: [
      '../../../../assets/icon/icofont/css/icofont.min.css'
   ]
})
export class IcofontComponent implements OnInit {
   @Input() ico: string = 'icofont-plus';
   
   constructor() {
   }
   
   ngOnInit() {
   }
}
